import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enUS from './en-us.json'
import ptBR from './pt-br.json'
import es from './es.json'

i18next
  .use(initReactI18next)
  .init({
    resources: {
      "en": {
        translation: enUS
      },
      "pt_br": {
        translation: ptBR
      },
      "es": {
        translation: es
      }
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18next